export default __webpack_public_path__ + "static/media/left.5ec3d052.svg";